import React from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  InputGroup,
  Table
} from "reactstrap";
import SidebarCustom from "views/pages/forms/Production/SidebarCustom.js";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';

export default class ComponentSumMultiTimer extends React.Component {
	state={
		dataArr:[]
	}
	componentDidMount(){
	}
    componentDidUpdate(prevProps, prevState){
        if (prevProps.data !== this.props.data) {
	    	if (this.props.data!=undefined) {
	    		if (this.props.data!='') {
		    		if (typeof this.props.data=='string') {
		    			var dataJson = JSON.parse(this.props.data)
		    			var objDateRelease = []
		    			for (var i = 0; i < dataJson.length; i++) {
			    			var dateObj = new Date(dataJson[i].date)
							objDateRelease[i] = {
								date:dateObj,
								dateString:dataJson[i].dateString,
								timeInit:dataJson[i].timeInit,
								timeEnd:dataJson[i].timeEnd,
								sumTimer:dataJson[i].sumTimer
							}
		    			}
						if (this.state.dataArr.length==0) {
							this.setState({dataArr: objDateRelease})
						}
		    		}
	    		}
	    	}
        }
    }
	saveInfo = () => {
		this.props.saveDataFieldTimer(JSON.stringify(this.state.dataArr))
		this.props.openSiderMulti(false)
	}
	addField = (iData) => {
       var date = new Date()
       var completeDateAfter = date.toLocaleDateString("es-PA",{timeZone:'America/Panama'})
       var completeDateBefore = completeDateAfter.split('/')
       var completeDate = completeDateBefore[2]+'-'+completeDateBefore[0]+'-'+completeDateBefore[1]
       var timeString = String(date).split(":")[0].split(" ")[4]+':'+String(date).split(":")[1];
       var objDate = {date:date,dateString:completeDate,timeInit:timeString,timeEnd:timeString,sumTimer:0}
       this.setState(prevState => ({dataArr: [...prevState.dataArr, objDate] }) )
	}
	diff_hours = (dt2,dt1) => {
	  var diff =(dt2.getTime() - dt1.getTime()) / 1000;
	  diff /= (60 * 60);
	  return Math.abs(Math.round(diff));
	}
	changeDateTimer = (value,index,type) => {
		var getLenData = [...this.state.dataArr]
		var getPosData = {...getLenData[index]}

			if (type=="date") {
		       var date = value.toISOString()
		       getPosData["dateString"] = date.split('T')[0]
			}

		getPosData[type] = value
		getLenData[index]=getPosData

		var dt1 = new Date("October 13, 2014 "+getLenData[index].timeInit);
		var dt2 = new Date("October 13, 2014 "+getLenData[index].timeEnd);
		
		getPosData['sumTimer'] = this.diff_hours(dt1, dt2)
		getLenData[index]=getPosData
		this.setState({dataArr: getLenData })
		//this.setState(prevState => ({dataArr: [...prevState.dataArr, objDate] }) )
		//this.state.dataArr[index][type]=value
	}
	deleteTimerField = (index) => {
	    var getLenData = this.state.dataArr
	    getLenData.splice(index, 1);
	    this.setState({dataArr: getLenData})
	}
	render(){
		var contentDate = []
		for (var i = 0; i < this.state.dataArr.length; i++) {
			contentDate[i] = <><FormGroup>
		                      <InputGroup>
			                      <div className="col-md-4 p-0">
			                        <label className="font-semibold text-color-fod-blue" style={{fontSize: '11px'}}>
			                        	Fecha
			                        </label>
				                    <Calendar 
				                        style={{fontSize: '1rem',color: '#4b5563', height: 'auto'}}
				                        dateFormat="dd/mm/yy"
				                        className="p-inputtext-sm" 
				                        value={this.state.dataArr[i]?.date}
				                        id={i}
				                        onChange={(e) => {
				                        	this.changeDateTimer(e.target.value,e.target.id,'date')
				                          //this.state.dataArr[i]?.date = e.target.value
				                            //setDate(e.value)
				                          }}
				                        //showIcon
				                         />
			                      </div>
			                      <div className="col-md-3 p-0">
			                        <label className="font-semibold text-color-fod-blue" style={{fontSize: '11px'}}>
			                        	Hora Inicial
			                        </label>
			                        <Input
			                          id={i}
			                          style={{fontSize: '1rem',color: '#4b5563'}}
			                          value={ this.state.dataArr[i]?.timeInit }
			                          onChange={(e) => {
			                          	this.changeDateTimer(e.target.value,e.target.id,'timeInit')
			                          }}
			                          type="time" />
			                      </div>

			                      <div className="col-md-3 p-0">
			                        <label className="font-semibold text-color-fod-blue" style={{fontSize: '11px'}}>
			                        	Hora Final
			                        </label>
			                        <Input
			                          id={i}
			                          style={{fontSize: '1rem',color: '#4b5563'}}
			                          value={ this.state.dataArr[i]?.timeEnd }
			                          onChange={(e) => {
			                          	this.changeDateTimer(e.target.value,e.target.id,'timeEnd')
			                          }}
			                          type="time" />
			                      </div>

			                      <div className="col-md-1 p-0">
			                        <label className="font-semibold text-color-fod-blue" style={{fontSize: '11px'}}>
			                        	Suma H
			                        </label>
			                        <Input
			                          style={{fontSize: '1rem',color: '#4b5563'}}
			                          value={ this.state.dataArr[i]?.sumTimer }
			                          //onChange={(e) => {console.log(e.target.value)}}
			                          type="number" 
			                          disabled />
			                      </div>

			                      <div className="col-md-1 p-0">
							          <button className="btn" style={{height: '100%'}} id={i} onClick={(e)=>{ this.deleteTimerField(e.target.id) }}>
							            <span className="fas fa-trash-alt"></span>
							          </button>
			                      </div>
		                      </InputGroup>
						  </FormGroup>
						  </>
		}
		return (<>
		      <SidebarCustom 
		          onVisible={this.props.openVisibleSider} 
		          onHide={() => this.props.openSiderMulti(false) }
		          onWidth={ 650 }
		          position="left" 
		          title="Multi Registro">
		          {contentDate}
                  <Button 
                    label="+ Añadir"
                    severity="secondary"
                    //id={props.content[i].name_field}
                    onClick={(e) => {this.addField('new')}}
                    size="small" 
                  />
	            <div className="absolute z-2 bottom-0 right-0 w-full surface-200 border-top-1 border-400">
	                <div className="flex justify-content-end pt-3 pr-3 pl-3">
	                    <div className="formgrid grid">
	                        <div className="field col">
	                            <Button 
	                                label="Cerrar"
	                                 severity="secondary" 
	                                 onClick={() => {
	                                  this.props.openSiderMulti(false)
	                                  //this.props.hide()
	                                }} size="small" />
	                        </div>

	                        <div className="field col">
	                            <Button 
	                            //disabled={this.state.btnd}
	                            onClick={()=>{
	                              this.saveInfo()
	                            }} label="Guardar" size="small" className='btn-fod-green' />
	                        </div>
	                    </div>
	                </div>
	            </div>
						  <br />
						  <br />
						  <br />
						  <br />
		      </SidebarCustom>
			</>)
	}
}